<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-container>
      <v-row>
        <v-col>
          <v-radio-group v-model="priceType" row @change="onPriceTypeChange">
            <v-radio label="Cost" value="cost"></v-radio>
            <v-radio label="Sell" value="sell"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row v-for="er in exchangeRates" :key="er.currencyCode">
        <v-col>
          <v-text-field
            type="number"
            :label="er.currencyCode"
            v-model="er.exchangeRate"
            :outlined="outlinedInputs"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-row v-if="debug">
      <v-col>
        <code>
          {{ exchangeRates }}
        </code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onUpdate">Update</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import { uniqueByProp } from "../../../../../helpers";
import BasicDialog from "../../../shared/BasicDialog.vue";
export default {
  name: "exchange-rate-updater",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      priceType: "cost",
      exchangeRates: [],
    };
  },

  computed: {
    editorTitle() {
      return `Update ${this.priceType} exchange rate`;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    items(newVal) {
      this.exchangeRates = this.getExchangeRates();
    },
  },

  methods: {
    onUpdate() {
      this.$emit("update-exchange-rates", {
        priceType: this.priceType,
        exchangeRates: [...this.exchangeRates],
        items: [...this.items],
      });
    },
    onPriceTypeChange() {
      this.exchangeRates = this.getExchangeRates();
    },
    getExchangeRates() {
      const pType = this.priceType == "cost" ? "Buy" : "Sell";
      const pricings = uniqueByProp(
        this.items.map((item) => item.pricing),
        `currency${pType}`
      );
      return pricings.map((p) => ({
        currencyCode: p[`currency${pType}`],
        exchangeRate: p[`currency${pType}ExchangeRate`],
      }));
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ExchangeRateUpdater.vue